import React from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import Hint from "../Hint/Hint";

import FieldErrorMessage from '../FieldErrorMessage';

const Radios = (props) => {
  const { label, name, options, defaultValue, isRequired, rules, hint } = props;
  const { register } = useFormContext();

  return (
    <div className={`row row--inline form-item form-item--radios`}>
      {label && <div className="col col-12 col-md-6 col-lg-4">
        <h3>
          {label}
          {isRequired && <span className="required">*</span>}
          {hint && <Hint hint={hint}/>}
        </h3>
      </div>}
      <div className="col col-12 col-md-6 col-lg-6">
        <div className="row">
          {options.map((item) => {
            return (
              <div
                key={`${name}-option-${item.value}`}
                className="form-item form-item--radio col col-4"
              >
                <input
                  name={name}
                  id={`${name}-option-${item.value}`}
                  type="radio"
                  value={item.value}
                  ref={register(rules)}
                  defaultChecked={item.value === defaultValue}
                />
                <label htmlFor={`${name}-option-${item.value}`}>{item.label}</label>
              </div>
            );
          })}
        </div>
        <FieldErrorMessage name={name} />
      </div>
    </div>
  );
};

Radios.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isRequired: PropTypes.bool,
  rules: PropTypes.objectOf(PropTypes.any),
};

Radios.defaultProps = {
  isRequired: true,
  defaultValue: null,
  rules: null,
};

export default Radios;
